export const getBooleanTextValue = value => value ? 'Да' : 'Нет'